export default __webpack_public_path__ + "static/media/cart.04beb78d.svg";